<template>
    <div class="row match-height">
        <div class="col-xl-12 col-md-12 col-12">
            <div class="card card-statistics">
                <div class="card-header">
                    <h4 class="card-title">Switchmail Statistics</h4>
                    <div class="d-flex align-items-center">
                        <p class="card-text font-small-2 me-25 mb-0"></p>
                    </div>
                </div>
                <div class="card-body statistics-body">
                    <div class="row">
                        <div class="col-xl-4 col-sm-6 col-12 mb-2">
                            <div class="d-flex flex-row">
                                <div class="avatar bg-light-primary me-2">
                                    <div class="avatar-content">
                                        <vue-feather type="user" />
                                    </div>
                                </div>
                                <div class="my-auto ml-1" >
                                    <h4 class="fw-bolder mb-0">
                                        {{ statistics.users }}
                                    </h4>
                                    <p class="card-text font-small-3 mb-0">Number of Users</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-sm-6 col-12 mb-2">
                            <div class="d-flex flex-row">
                                <div class="avatar bg-light-primary me-2">
                                    <div class="avatar-content">
                                        <vue-feather type="mail" />
                                    </div>
                                </div>
                                <div class="my-auto ml-1" >
                                    <h4 class="fw-bolder mb-0">
                                        {{ statistics.certified_mails_count }}
                                    </h4>
                                    <p class="card-text font-small-3 mb-0">Total Number of Certified Mails</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-sm-6 col-12 mb-2">
                            <div class="d-flex flex-row">
                                <div class="avatar bg-light-warning me-2">
                                    <div class="avatar-content">
                                        <vue-feather type="mail" />
                                    </div>
                                </div>
                                <div class="my-auto ml-1" >
                                    <h4 class="fw-bolder mb-0">
                                        {{ statistics.firstclass_mails_count }}
                                    </h4>
                                    <p class="card-text font-small-3 mb-0">Total Number Of Firstclass</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-sm-6 col-12 mb-2">
                            <div class="d-flex flex-row">
                                <div class="avatar bg-light-info me-2">
                                    <div class="avatar-content">
                                        <vue-feather type="mail" />
                                    </div>
                                </div>
                                <div class="my-auto ml-1" >
                                    <h4 class="fw-bolder mb-0">N/A</h4>
                                    <p class="card-text font-small-3 mb-0">Total Number of Priority Mail</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-sm-6 col-12 mb-2 mb-sm-0">
                            <div class="d-flex flex-row">
                                <div class="avatar bg-light-primary me-2">
                                    <div class="avatar-content">
                                        <vue-feather type="dollar-sign" />
                                    </div>
                                </div>
                                <div class="my-auto ml-1" >
                                    <h4 class="fw-bolder mb-0">
                                        {{ fix(statistics.firstclass_mails_cost, 2).toFixed(2) }}
                                    </h4>
                                    <p class="card-text font-small-3 mb-0">
                                        Total Cost Spent For First Class
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-sm-6 col-12">
                            <div class="d-flex flex-row">
                                <div class="avatar bg-light-warning me-2">
                                    <div class="avatar-content">
                                        <vue-feather type="dollar-sign" />
                                    </div>
                                </div>
                                <div class="my-auto ml-1" >
                                    <h4 class="fw-bolder mb-0">N/A</h4>
                                    <p class="card-text font-small-3 mb-0">
                                        Total Cost Spent For Priority
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-sm-6 col-12">
                            <div class="d-flex flex-row">
                                <div class="avatar bg-light-info me-2">
                                    <div class="avatar-content">
                                        <vue-feather type="dollar-sign" />
                                    </div>
                                </div>
                                <div class="my-auto ml-1" >
                                    <h4 class="fw-bolder mb-0">
                                        {{ fix(statistics.certified_mails_cost, 2).toFixed(2) }}
                                    </h4>
                                    <p class="card-text font-small-3 mb-0">
                                        Total Cost Spent For Certified
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js';
    import { fix } from 'mathjs'
    export default {
        components: {
        },
        setup(props) {
            return {
                localizationStore: useLocalizationStore(),
                statistics: reactive({
                    users: 0,
                    certified_mails_count: 0,
                    firstclass_mails_count: 0,
                    certified_mails_cost: 0,
                    firstclass_mails_cost: 0,
                }),
                fix: fix,
            }
        },
        mounted() {
            let $this = this;
            const route = this.$router.resolve(
                {
                    name: 'mails-statistics',
                }
            );
            axios.post(route.href).then(function(response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                Object.assign($this.statistics, response.data.data);
                return;
            }).catch(function(error) {
                setTimeout(() => {
                    toastr.error(error.response.data.response_msg, 'Error!');
                }, 2000)
            });
        },
        watch: {
        },
        methods: {
        }
    }
</script>